import { IBaseAlphaUIConfig, IBaseAlphaUIEvents } from "./types";

class BaseAlphaUI {
  private static _config: IBaseAlphaUIConfig | null = null;
  private static _events: IBaseAlphaUIEvents = {
    onSignOut: [],
  };

  private static _defaultConfig = {
    oauthUrl: "/oauth",
  };

  static configure(config: IBaseAlphaUIConfig) {
    this._config = config;
  }

  static getAppName() {
    return this._config?.appName;
  }

  static getAuthApiName() {
    return this._config?.authApiName;
  } 
  
  static getOauthUrl() {
    return this._config?.oauthUrl || this._defaultConfig.oauthUrl;
  }

  static pushSignOutEvent(event: () => Promise<void> | void): void {
    this._events.onSignOut.push(event);
  }

  static getSignOutEvents() {
    return this._events.onSignOut;
  }
}

export default BaseAlphaUI;
